import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import Axios from "../../../Axios.js";
import PopupConfirmUser from "./PopupConfirmUser.jsx";
import ModalUser from "./ModalUser.tsx";
import User from "./User.tsx";
import APIRequest from "../../../JS/APIRequest.ts";
import AreYouSure from "../../AreYouSure.tsx";
import { Filter, Filters } from "../../Filters.tsx";

export function Users() {
  const { t } = useTranslation();
  const [nbPage, setNbPage] = useState(1);
  const [nbUserShow, setNbUserShow] = useState(20);
  const [maxPage, setMaxPage] = useState(1);

  const [currentUser, setCurrentUser] = useState();
  const [listUser, setListUser] = useState([]);
  const [listRole, setListRole] = useState([]);
  const [listAbilities, setListAbilities] = useState([]);
  const [listUsersRole, setListUsersRole] = useState([]);
  const [listUsersAbilities, setListUsersAbilities] = useState([]);
  const [listRolesAbilities, setListRolesAbilities] = useState([]);

  const [showPopupConfirm, setShowPopupConfirm] = useState(false);
  const [modal, setModal] = useState(false);
  const [filters, setFilters] = useState<string[]>([]);
  const [input, setInput] = useState<string>('');
  const [order, setOrder] = useState<'none' | 'ascending' | 'descending'>('none');
  const [sortedList, setSortedList] = useState([...listUser]);

  const [confirmModal, setConfirmModal] = useState();

  function handleFiltersChange() {
    const new_list = listUser.filter((user) =>
      (typeof user.firstname === "string" && user.firstname.toLowerCase().includes(input.toLowerCase())) ||
      (typeof user.lastname === "string" && user.lastname.toLowerCase().includes(input.toLowerCase()))
    );
    setSortedList(new_list);
  }

  useEffect(() => {
    handleFiltersChange();
  }, [filters, input, order]);

  useEffect(() => {
    setSortedList([...listUser]);
  }, [listUser]);

  const getMaxPage = async () => {
    try {
      const response = await Axios.get(`/api/users/getmaxpage/?limit=${nbUserShow}`, {
        headers: {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token")
        },
        withCredentials: true
      });
      if (response.status === 200) {
        setMaxPage(response.data);
      }
    } catch (error) {
      console.error("Error during getMaxPage:", error);
    }
  };

  const getUsers = async () => {
    try {
      const response = await Axios.get(`/api/users/getallwithlimit/?limit=${nbUserShow}&offset=${(nbPage - 1) * nbUserShow}`, {
        headers: {
          "auth-token": sessionStorage.getItem("token")
        },
        withCredentials: true
      });
      if (response.status === 200) {
        setListUser([...response.data].sort((a, b) =>
          a.firstname.localeCompare(b.firstname)
        ));
      } else {
        alert(t("Upload failed"));
      }
    } catch (error) {
      console.error("Error during getUsers:", error);
    }
  };

  const pageNext = () => setNbPage(nbPage + 1);
  const pagePrevious = () => setNbPage(nbPage - 1);

  const handleDeleting = (user) => {
    setConfirmModal(
      <AreYouSure
        title={`${t("Are you sure you want to delete")} ${user.firstname} ${user.lastname}?`}
        message={t("This is permanent! It will break existing links.")}
        callback={(res) => {
          setConfirmModal(undefined);
          if (res) {
            // Suppression à implémenter ici
          }
        }}
      />
    );
  };

  const handleModify = (user) => {
    setCurrentUser(user);
    setModal(true);
  };

  const getPageNumbers = () => {
    const pages = [];
    if (maxPage <= 5) {
      for (let i = 1; i <= maxPage; i++) pages.push(i);
    } else if (nbPage <= 3) {
      pages.push(1, 2, 3, 4, 5, "...", maxPage);
    } else if (nbPage > maxPage - 3) {
      pages.push(1, "...", maxPage - 4, maxPage - 3, maxPage - 2, maxPage - 1, maxPage);
    } else {
      pages.push(1, "...", nbPage - 1, nbPage, nbPage + 1, "...", maxPage);
    }
    return pages;
  };

  const getUsersRole = (user) => {
    return listUsersRole
      .filter((ur) => ur.id_user === user.id && ur.value > 0 && ur.value <= 4)
      .map((ur) => ({ role: listRole.find((role) => role.id_role === ur.id_role), value: ur.value }))
      .sort((a, b) => a.role.name.localeCompare(b.role.name));
  };

  const getUsersAbilities = (user) => {
    return listUsersAbilities
      .filter((ua) => ua.id_user === user.id)
      .map((ua) => listAbilities.find((ab) => ab.id_ability === ua.id_ability))
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  useEffect(() => {
  setSortedList([...listUser]);
}, [listUser]);

  useEffect(() => {
    async function fetchData() {
      await getUsers();
      await getMaxPage();
      await APIRequest.fetchData({
        setRoles: setListRole,
        setUsers: setListUser,
        setAbilities: setListAbilities,
        setUsersRoles: setListUsersRole,
        setUsersAbilities: setListUsersAbilities,
        setRolesAbilities: setListRolesAbilities,
      });
    }
    fetchData();
  }, [nbUserShow, nbPage]);

  const refreshData = async () => {
  await getUsers();
  await getMaxPage();
  await APIRequest.fetchData({
    setRoles: setListRole,
    setUsers: setListUser,
    setAbilities: setListAbilities,
    setUsersRoles: setListUsersRole,
    setUsersAbilities: setListUsersAbilities,
    setRolesAbilities: setListRolesAbilities,
  });
};


  return (
    <div className="items-center my-2">
      <div className="flex justify-center">
        <Filters
          filters={[new Filter("sort_users", "sort", [], true)]}
          handleSearchBarChange={(input, order) => {
            setOrder(order);
            setInput(input);
          }}
          handleFiltersChange={setFilters}
        />
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          onClick={() => {
            setCurrentUser(null);
            setModal(true);
          }}
        >
          {t("add user")}
        </button>
      </div>

      {sortedList.length > 0 ? (
        <div>
          <div className="w-full flex flex-wrap justify-center">
            {sortedList.map((user, index) => (
              <div key={user.id}>
                <User
                  user={user}
                  index={index}
                  setCurrentUser={setCurrentUser}
                  setShowPopupConfirm={setShowPopupConfirm}
                  setModal={setModal}
                  handleDeleting={handleDeleting}
                  handleModify={handleModify}
                  usersRoles={getUsersRole(user)}
                  usersAbilities={getUsersAbilities(user)}
                  t={t}
                />
              </div>
            ))}
          </div>
          <div className="w-full flex justify-center">
            <div className="flex justify-center absolute ml-auto">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                onClick={pagePrevious}
                disabled={nbPage === 1}
              >
                {t("previous")}
              </button>
              {getPageNumbers().map((page, index) =>
                page === "..." ? (
                  <span key={index} className="mx-2">...</span>
                ) : (
                  <button
                    key={index}
                    className={`mx-2 px-4 py-2 rounded ${nbPage === page ? "bg-blue-700 text-white" : "bg-gray-200 text-gray-800"}`}
                    onClick={() => setNbPage(page)}
                  >
                    {page}
                  </button>
                )
              )}
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                onClick={pageNext}
                disabled={nbPage === maxPage}
              >
                {t("next")}
              </button>
            </div>
            <div className="flex ml-auto">
              <p className="text-gray-800 my-2 mx-2">{t("show")}</p>
              <select
                className="border-2 border-gray-500 rounded"
                onChange={(e) => {
                  setNbUserShow(parseInt(e.target.value));
                  setNbPage(1);
                }}
                value={nbUserShow}
              >
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="60">60</option>
                <option value="80">80</option>
              </select>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center">{t("no user")}</div>
      )}

      <ModalUser
        isOpen={modal}
        toggle={() => {
          setModal(false);
          setCurrentUser(null);
        }}
        currentUser={currentUser}
        onClose={() => {
          setModal(false);
          setCurrentUser(null);
          refreshData();

        }}

        listRole={listRole}
        listAbilities={listAbilities}
        listRolesAbilities={listRolesAbilities}
        listUsersRole={listUsersRole}
        listUsersAbilities={listUsersAbilities}
        getMaxPage={getMaxPage}
        setNbPage={setNbPage}
      />

      <PopupConfirmUser
        getUsers={getUsers}
        currentUser={currentUser}
        getMaxPage={getMaxPage}
        setNbPage={setNbPage}
        setShow={setShowPopupConfirm}
        show={showPopupConfirm}
        setShowPopupConfirm={setShowPopupConfirm}
        setNbUserShow={setNbUserShow}
      />

      {confirmModal}
    </div>
  );
}
